export default "__VITE_ASSET__6db8c14d__"